import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUiVersion } from '../../reducers/uiVersionSlice';
import { Sparkles, Layers } from 'lucide-react';

export default function VersionSwitch({ variant = 'pill' }) {
  const dispatch = useDispatch();
  const currentVersion = useSelector((state) => state.uiVersion?.version || 'v2');

  const handleSelect = (v) => {
    if (v !== currentVersion) {
      dispatch(setUiVersion(v));
    }
  };

  if (variant === 'sidebar') {
    return (
      <div className="im-version-switch-sidebar">
        <div className="im-switch-label">
          <span>Experiencia UI</span>
        </div>
        <div className="im-segmented-control">
          <button
            type="button"
            className={`im-segmented-btn ${currentVersion === 'v1' ? 'active' : ''}`}
            onClick={() => handleSelect('v1')}
            title="Versión Clásica v1"
          >
            <Layers size={13} className="me-1" />
            <span>v1 Clásica</span>
          </button>
          <button
            type="button"
            className={`im-segmented-btn ${currentVersion === 'v2' ? 'active' : ''}`}
            onClick={() => handleSelect('v2')}
            title="Nueva Versión Moderna v2"
          >
            <Sparkles size={13} className="me-1" />
            <span>v2 Nueva</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`im-segmented-control im-version-switch-${variant}`}>
      <button
        type="button"
        className={`im-segmented-btn ${currentVersion === 'v1' ? 'active' : ''}`}
        onClick={() => handleSelect('v1')}
        title="Versión v1 Clásica"
      >
        <Layers size={13} className="me-1" />
        <span>v1<span className="d-none d-sm-inline"> Clásica</span></span>
      </button>
      <button
        type="button"
        className={`im-segmented-btn ${currentVersion === 'v2' ? 'active' : ''}`}
        onClick={() => handleSelect('v2')}
        title="Versión v2 Nueva"
      >
        <Sparkles size={13} className="me-1 text-primary-v2" />
        <span>v2<span className="d-none d-sm-inline"> Nueva</span></span>
      </button>
    </div>
  );
}
